import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import TagManager from "react-gtm-module";
import i18n from "i18next";

if (process.env.REACT_APP_THEME_SCSS_FILE_LOCATION) {
  require(`${process.env.REACT_APP_THEME_SCSS_FILE_LOCATION}`);
}

const {
  REACT_APP_GTM_DISABLE,
  REACT_APP_GTM_AUTH,
  REACT_APP_GTM_PREVIEW,
  REACT_APP_GTM_ID,
  REACT_APP_BASE_URL,
  REACT_APP_CLIENT_ID,
} = process.env;

if (!REACT_APP_BASE_URL || !REACT_APP_CLIENT_ID) {
  throw Error("Please set the app client id and base URL!");
}

if (
    process.env.NODE_ENV !== "development" &&
    REACT_APP_GTM_DISABLE !== "true"
) {
  if (!REACT_APP_GTM_AUTH || !REACT_APP_GTM_PREVIEW || !REACT_APP_GTM_ID) {
    throw Error("Please set Google Tag Manager environment variables!");
  }
  const tagManagerArgs = {
    gtmId: REACT_APP_GTM_ID,
    auth: REACT_APP_GTM_AUTH,
    preview: REACT_APP_GTM_PREVIEW,
  };

  TagManager.initialize(tagManagerArgs);
}

const loadUsercentricsScript = () => {
  const existingScript = document.getElementById("usercentrics-cmp");
  if (existingScript) {
    existingScript.setAttribute("data-language", i18n.language);
  } else {
    const script = document.createElement("script");
    script.id = "usercentrics-cmp";
    script.setAttribute("async", "async");
    script.setAttribute("data-block-data-layer-push", "1");
    script.setAttribute("data-language", i18n.language);
    script.setAttribute("data-version", "preview");
    script.setAttribute("data-settings-id", process.env.REACT_APP_CONSENT_MGMT || "");
    script.src = "https://app.usercentrics.eu/browser-ui/latest/loader.js";
    document.head.appendChild(script);
  }
};

// Ensure i18n is ready before setting the script attribute
i18n.on("initialized", loadUsercentricsScript);
i18n.on("languageChanged", loadUsercentricsScript);
loadUsercentricsScript(); // Initial load

ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById("root")
);

serviceWorkerRegistration.register();
reportWebVitals();
